import React from 'react';

import classes from './Logout.css';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';

const logout = () => (
    <div className={classes.Logout}>
        <DisplayBox>
            <p>Thank you for using HealthSafeID Administrator!</p>
            <p><a href={process.env.REACT_APP_ADMIN_SERVICE_HOST}>Start here again</a></p>
        </DisplayBox>
    </div>
);

export default logout;